import React from 'react'
import { Modal } from 'react-bootstrap'
import PropTypes from 'prop-types'
import "./style.sass"
import closeIcon from '../../../assets/icons/close-icon.svg'
import CustomButton from '../CustomButton'


const CenteredModal = ({
  show,
  onHide,
  title,
  titlePrefixIcon,
  children,
  onSuccess,
  cancelBtnText,
  successBtnText,
  btnDisabled,
  showSuccessBtn = true,
  showCancelBtn = true }) => {

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      dialogClassName="customized-centerd-modal"
    >
      <Modal.Header closeButton={false}>
        <Modal.Title id="contained-modal-title-vcenter" className="title">
          {!titlePrefixIcon || (
            <img src={titlePrefixIcon} alt='icon' className="title-prefix-icon" />
          )}
          {title}
        </Modal.Title>
        <img src={closeIcon} alt='close' className="close-icon" onClick={() => !btnDisabled && onHide(true)} />
      </Modal.Header>
      <Modal.Body>
        {children}
      </Modal.Body>
      <Modal.Footer>
        {showSuccessBtn && (
          <CustomButton
            className={`btn btn-fill`}
            buttonText={successBtnText || "Ok"}
            onClick={onSuccess}
            disabled={btnDisabled}
          />
        )}
        {showCancelBtn && (
          <CustomButton
            className={`btn btn-outline`}
            buttonText={cancelBtnText || "Cancel"}
            onClick={onHide}
            disabled={btnDisabled}
          />
        )}
      </Modal.Footer>
    </Modal>
  )
}

CenteredModal.propTypes = {
  show: PropTypes.bool.isRequired,
  showSuccessBtn: PropTypes.bool,
  showCancelBtn: PropTypes.bool,
  title: PropTypes.string,
  titlePrefixIcon: PropTypes.string,
  children: PropTypes.element,
  onHide: PropTypes.func,
  onSuccess: PropTypes.func,
  btnDisabled: PropTypes.bool,
}

export default CenteredModal